module.exports = __webpack_public_path__ + "img/logo-symbol-dark@3x.b575d4a1.png";